import { invalidateAllCaches } from './cacheRefresh';

/**
 * Shared refresh handler for mobile screens
 * Invalidates all caches and refetches data from all relevant slices
 *
 * @param {Object} params - Parameters object
 * @param {string} params.userId - User ID for fetching data
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {Function} params.setLoading - Optional loading state setter
 * @param {Function} params.setRefreshing - Optional refreshing state setter
 * @returns {Promise<void>}
 */
export const handleMobileRefresh = async ({
  userId,
  dispatch,
  setLoading,
  setRefreshing
}) => {
  console.log('🔄 Mobile refresh triggered - refreshing all data');

  // Set loading states if provided
  if (setLoading) setLoading(true);
  if (setRefreshing) setRefreshing(true);

  try {
    // Invalidate all caches to force fresh data
    invalidateAllCaches();

    // Import all the fetch actions dynamically to avoid circular dependencies
    const { fetchPolicies } = await import('../features/policies/policySlice');
    const { fetchClients } = await import('../features/clients/clientSlice');
    const { fetchMeetings } = await import('../features/meetings/meetingsSlice');

    // Fetch fresh data from all slices in parallel
    const refreshPromises = [];

    if (userId) {
      // Refresh policies data
      refreshPromises.push(dispatch(fetchPolicies(userId)));

      // Refresh clients data
      refreshPromises.push(dispatch(fetchClients({ agentId: userId })));

      // Refresh meetings data
      refreshPromises.push(dispatch(fetchMeetings(userId)));
    }

    // Wait for all data to be refreshed
    await Promise.all(refreshPromises);

    console.log('✅ All mobile data refreshed successfully');

  } catch (error) {
    console.error('❌ Error during mobile refresh:', error);
    throw error;
  } finally {
    // Clear loading states if provided
    if (setLoading) setLoading(false);
    if (setRefreshing) setRefreshing(false);
  }
};
